export const MESSAGE_STATS_PERMISSION_RESOURCE = 'social-trading-message-stats';

/** Upstream rejects a longer span with MESSAGE_STATS_RANGE_TOO_LONG. */
export const MESSAGE_STATS_MAX_DAYS = 31;

/** The FE default window — the backend has no default of its own. */
export const MESSAGE_STATS_DEFAULT_DAYS = 7;
export const MESSAGE_STATS_DEFAULT_TIME_ZONE = 'Asia/Shanghai';

/**
 * A fixed list: upstream wants IANA zone names, and a free-text field invites
 * the `+08:00` offsets the BFF rejects outright.
 */
export const MESSAGE_STATS_TIME_ZONES = [
  'Asia/Shanghai',
  'Asia/Ho_Chi_Minh',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Asia/Dubai',
  'Europe/London',
  'America/New_York',
  'UTC',
] as const;
